import { trackRegisterClick } from '../utils/analytics';

/** All CTA / outbound links point to the landing target URL */
export const AFFILIATE_URL = 'https://i9aus.net/RFLANDINBGPAGE';

export const affiliateLinkProps = {
  target: '_blank' as const,
  rel: 'noopener noreferrer',
};

/** Outbound link props with register_click tracking by section source */
export function getAffiliateLinkProps(source: string, label?: string) {
  return {
    ...affiliateLinkProps,
    onClick: () => trackRegisterClick(source, label),
  };
}
